import API from '../interceptors/Api';

export const getNotifications = (params) => API.get('/notifications', { params });

export const getNotificationsRefresh = (params) => API.get('/notifications/refresh', { params });

export const getNotificationDetail = (id) => API.get(`/notifications/${id}`);

export const markAllNotificationsAsRead = () => API.patch('/notifications');

export const markNotification = (id, read) => API.patch(`/notifications/${id}/read/${read}`);
